import React from 'react';
import bannerImage from './banner.png';
import logoTotvs from './logo-totvs-branco.svg';
import './banner.css';
import { t, getCurrentLanguage } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class Banner2610 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div
                className="banner"
                style={{
                    backgroundImage: `url(${bannerImage})`
                }}
            >
                <div className="banner-info">
                    <p className='banner-info-product'><strong>{t('linha_protheus', currentLanguage)}</strong></p>
                    <img 
                        src={logoTotvs} 
                        alt="TOTVS Logo" 
                        className="banner-info-logo"
                    />
                </div>
                <div className="banner-content">
                    <div className="banner-title">
                        <p className="banner-title-light">{t('atualizacao_release', currentLanguage)}</p>
                        <p className="banner-title-release"><strong>12.1.2610</strong></p>
                    </div>
                </div>
                <a href="https://tdn.totvs.com/x/Xs2hQQ" className="banner-text-link" target="_blank" rel="noopener noreferrer">
                    <div className="banner-text">
                        <p>{t('informacoes_gerais', currentLanguage)}</p>
                    </div>
                </a>
                
            </div>
        );
    };
};

export default Banner2610;
